module.exports = __webpack_public_path__ + "static/media/30OIOS1.bbc85611.jpg";